import { createContext } from 'react';
import { LeaderboardTypes } from './leaderboardTypes';

const leaderboardContext = createContext({} as LeaderboardTypes);
leaderboardContext.displayName = 'LeaderboardContext';

export default leaderboardContext;
